import { GameState, gameStates } from './machine/state-types';
import { allowToBet, gameRoundInfo, multipliers } from '../store';
import {
    applyTopSlotToBonusGame,
    wait,
    waitForBonusTransitionToFinish,
    waitForEvent,
    waitForPlayClick
} from './machine/helpers';
import { backend } from '../backend';
import { playAudio, stopAudio, getAudio } from '../utils/audio';
import { get } from 'svelte/store';

let beforePlinko = false;

export const state: GameState = {
    name: gameStates.plinko,
    onEnter: async setState => {
        addEventListener('plinko-hit-pin', onHitPin);
        addEventListener('plinko-touch-basket', onTouchBasket);
        addEventListener('plinko-touch-double', onTouchDouble);

        await waitForBonusTransitionToFinish();

        const plinkoParams = get(gameRoundInfo).resp.plinko_params;
        multipliers.set(JSON.stringify(plinkoParams.multipliers));

        await applyTopSlotToBonusGame();
        await wait(0.5);

        if (!beforePlinko)
            dispatchEvent(new CustomEvent('start-wave'));

        allowToBet.set(true);
        playAudio('audio_plinko_start_position', { volume: 0.3, loop: true, fade: null });
        await waitForPlayClick();
        playAudio('audio_plinko_multipliers_appearance');
        allowToBet.set(false);

        const result = await backend.playBonus('PLINKO');

        gameRoundInfo.set(result);
        stopAudio(getAudio('audio_plinko_start_position'));
        const { path, bucket } = result.resp.plinko_result;
        dispatchEvent(new CustomEvent('start-game', { detail: { path, bucket } }));

        await waitForEvent('ball-finish');

        beforePlinko = false;
        if (result.final) setState(gameStates.bigWin);
        else {
            setState(gameStates.plinko);
            beforePlinko = true;
        }

    },
    onExit: () => {
        removeEventListener('plinko-hit-pin', onHitPin);
        removeEventListener('plinko-touch-basket', onTouchBasket);
        removeEventListener('plinko-touch-double', onTouchDouble);
    }
};

function onHitPin() {
    playAudio('audio_plinko_collide');
}

function onTouchBasket() {
    playAudio('audio_plinko_mult_win');
}

function onTouchDouble() {
    playAudio('audio_wof_double_win');
    playAudio('audio_plinko_double');
}
